// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nsw-side-nav ol {
  padding: 0;
  margin: 0;
  list-style: none;
}

.nsw-side-nav > ol > li.active {
  border-left: solid 2px #d7153a;
}

.nsw-side-nav li {
  margin: 0;
  border-top: solid 1px #ebebeb;
}

.nsw-side-nav li li a {
  padding-left: 24px;
}

.nsw-side-nav li li li a {
  padding-left: 32px; 
}

.nsw-side-nav li li li li a {
  padding-left: 48px;
}

.nsw-side-nav li.active > a {
  font-weight: 700;
}

.nsw-side-nav a {
  font-weight: 400;
  display: block;
  text-decoration: none;
  color: #22272b;
  padding: 16px;
}

.nsw-side-nav a:hover {
  outline-width: 0;
}

.nsw-side-nav a:focus {
  outline-width: 3px;
}

.nsw-side-nav a.current {
  background-color: #f2f2f2;
}

.nsw-side-nav__header {
  border-bottom: solid 2px #002664;
}

.nsw-side-nav__header a {
  font-weight: 700;
  padding: 8px 0;
}

.nsw-side-nav__header + ol > li:first-child {
  border-top: 0;
}


.nsw-side-nav ol {
  padding: 0;
  margin: 0;
  list-style: none;
}

.nsw-side-nav li.active {
  border-left: solid 2px #d7153a;
}

.nsw-side-nav li {
  margin: 0;
  border-top: solid 1px #ebebeb;
}

  .nsw-side-nav li:hover {
    background-color: #e5e9ef;
  }

  .nsw-side-nav li li a {
    padding-left: 24px;
  }

  .nsw-side-nav li li li a {
    padding-left: 32px; 
  }

  .nsw-side-nav li li li li a {
    padding-left: 48px;
  }

  .nsw-side-nav li.active > a {
    font-weight: 700;
  }

.nsw-side-nav a {
  font-weight: 400;
  display: block;
  text-decoration: none;
  color: #22272b;
  padding: 16px;
}

  .nsw-side-nav a:hover {
    outline-width: 0;
  }

  .nsw-side-nav a:focus {
    outline-width: 3px;
  }

  .nsw-side-nav a.current {
    background-color: #f2f2f2;
  }

.nsw-side-nav__header {
  border-bottom: solid 2px #002664;
}

  .nsw-side-nav__header a {
    font-weight: 700;
    padding: 8px 0;
  }

  .nsw-side-nav__header + ol > li:first-child {
    border-top: 0;
  }

.nsw-side-nav {
  width: 350px;
  padding-top: 24px;
  padding-top: 24px;
  padding-right: 24px;
}

.nsw-side-nav {
  height: 100%
}

@media only screen and (min-width: 992px) {
  @supports (position:sticky) {
    nav#left .region-left .nav-content {
      position: sticky;
      top: 1rem
    }

      nav#left .region-left .nav-content h2 {
        position: relative
      }

      nav#left .region-left .nav-content ol, nav#left .region-left .nav-content > ol.menu {
        -webkit-overflow-scrolling: touch;
        border-collapse: collapse;
        display: block;
        max-height: 98vh;
        max-height: calc(100vh - 76px - 1rem);
        overflow-x: visible;
        overflow-y: auto;
      }
  }
}

nav#left .region-left {
  height: 100%;
  width: 300px;
}

html {
  scroll-behavior: smooth;
}

nav#left .region-left .nav-content.hidden {
  display: none
}

@media only screen and (max-width: 991px) {
  nav#left {
    display: none
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/navigation/side-nav/side-nav.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;EAEE;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,aAAa;AACf;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;EACE,gCAAgC;AAClC;;EAEE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;AAEF;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE;IACE;MACE,gBAAgB;MAChB;IACF;;MAEE;QACE;MACF;;MAEA;QACE,iCAAiC;QACjC,yBAAyB;QACzB,cAAc;QACd,gBAAgB;QAChB,qCAAqC;QACrC,mBAAmB;QACnB,gBAAgB;MAClB;EACJ;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;AACF","sourcesContent":[".nsw-side-nav ol {\r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nsw-side-nav > ol > li.active {\r\n  border-left: solid 2px #d7153a;\r\n}\r\n\r\n.nsw-side-nav li {\r\n  margin: 0;\r\n  border-top: solid 1px #ebebeb;\r\n}\r\n\r\n.nsw-side-nav li li a {\r\n  padding-left: 24px;\r\n}\r\n\r\n.nsw-side-nav li li li a {\r\n  padding-left: 32px; \r\n}\r\n\r\n.nsw-side-nav li li li li a {\r\n  padding-left: 48px;\r\n}\r\n\r\n.nsw-side-nav li.active > a {\r\n  font-weight: 700;\r\n}\r\n\r\n.nsw-side-nav a {\r\n  font-weight: 400;\r\n  display: block;\r\n  text-decoration: none;\r\n  color: #22272b;\r\n  padding: 16px;\r\n}\r\n\r\n.nsw-side-nav a:hover {\r\n  outline-width: 0;\r\n}\r\n\r\n.nsw-side-nav a:focus {\r\n  outline-width: 3px;\r\n}\r\n\r\n.nsw-side-nav a.current {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.nsw-side-nav__header {\r\n  border-bottom: solid 2px #002664;\r\n}\r\n\r\n.nsw-side-nav__header a {\r\n  font-weight: 700;\r\n  padding: 8px 0;\r\n}\r\n\r\n.nsw-side-nav__header + ol > li:first-child {\r\n  border-top: 0;\r\n}\r\n\r\n\r\n.nsw-side-nav ol {\r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nsw-side-nav li.active {\r\n  border-left: solid 2px #d7153a;\r\n}\r\n\r\n.nsw-side-nav li {\r\n  margin: 0;\r\n  border-top: solid 1px #ebebeb;\r\n}\r\n\r\n  .nsw-side-nav li:hover {\r\n    background-color: #e5e9ef;\r\n  }\r\n\r\n  .nsw-side-nav li li a {\r\n    padding-left: 24px;\r\n  }\r\n\r\n  .nsw-side-nav li li li a {\r\n    padding-left: 32px; \r\n  }\r\n\r\n  .nsw-side-nav li li li li a {\r\n    padding-left: 48px;\r\n  }\r\n\r\n  .nsw-side-nav li.active > a {\r\n    font-weight: 700;\r\n  }\r\n\r\n.nsw-side-nav a {\r\n  font-weight: 400;\r\n  display: block;\r\n  text-decoration: none;\r\n  color: #22272b;\r\n  padding: 16px;\r\n}\r\n\r\n  .nsw-side-nav a:hover {\r\n    outline-width: 0;\r\n  }\r\n\r\n  .nsw-side-nav a:focus {\r\n    outline-width: 3px;\r\n  }\r\n\r\n  .nsw-side-nav a.current {\r\n    background-color: #f2f2f2;\r\n  }\r\n\r\n.nsw-side-nav__header {\r\n  border-bottom: solid 2px #002664;\r\n}\r\n\r\n  .nsw-side-nav__header a {\r\n    font-weight: 700;\r\n    padding: 8px 0;\r\n  }\r\n\r\n  .nsw-side-nav__header + ol > li:first-child {\r\n    border-top: 0;\r\n  }\r\n\r\n.nsw-side-nav {\r\n  width: 350px;\r\n  padding-top: 24px;\r\n  padding-top: 24px;\r\n  padding-right: 24px;\r\n}\r\n\r\n.nsw-side-nav {\r\n  height: 100%\r\n}\r\n\r\n@media only screen and (min-width: 992px) {\r\n  @supports (position:sticky) {\r\n    nav#left .region-left .nav-content {\r\n      position: sticky;\r\n      top: 1rem\r\n    }\r\n\r\n      nav#left .region-left .nav-content h2 {\r\n        position: relative\r\n      }\r\n\r\n      nav#left .region-left .nav-content ol, nav#left .region-left .nav-content > ol.menu {\r\n        -webkit-overflow-scrolling: touch;\r\n        border-collapse: collapse;\r\n        display: block;\r\n        max-height: 98vh;\r\n        max-height: calc(100vh - 76px - 1rem);\r\n        overflow-x: visible;\r\n        overflow-y: auto;\r\n      }\r\n  }\r\n}\r\n\r\nnav#left .region-left {\r\n  height: 100%;\r\n  width: 300px;\r\n}\r\n\r\nhtml {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\nnav#left .region-left .nav-content.hidden {\r\n  display: none\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  nav#left {\r\n    display: none\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
